import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';

import ru from './locales/ru.json';
import en from './locales/en.json';

const lng = (navigator.language || navigator.systemLanguage || navigator.userLanguage || navigator.languages[0])
  .substr(0, 2)
  .toLowerCase();

const languages = ['en', 'ru'];
const defaultLanguage = 'en';

i18n.use(XHR).init({
  resources: {
    en: { ui: en },
    ru: { ui: ru },
  },
  lng: languages.includes(lng) ? lng : defaultLanguage,
  ns: ['ui'],
  defaultNS: 'ui',
});

export default i18n;



// WEBPACK FOOTER //
// ./i18n.js